import { connect } from 'react-redux'
import { compose } from 'recompose';
import { reduxForm } from 'redux-form'
import LoginForm from '../components/loginForm';
import {login} from '../store/actions/login';

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onSubmit: (data) => {
            dispatch(login(data.username, data.password))
        }
    }
};

const formProps = {
    form: 'login'
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    reduxForm(formProps)
)(LoginForm);



// WEBPACK FOOTER //
// ./src/containers/LoginFormContainer.js